import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SiteMode } from '@classes/site-mode';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SiteModeService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/siteMode';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getSiteModes(): Observable<Array<SiteMode>> {
    return this.http.get<Array<SiteMode>>(this.basePath);
  }

  createOrUpdateSiteMode(siteMode?: SiteMode): Observable<SiteMode> {
    if (siteMode?.id) {
      //update
      const url = `${this.basePath}/${siteMode?.id}`;
      return this.http.patch<any>(url,
        siteMode).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        siteMode
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteSiteMode(siteModeId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${siteModeId}`;
    return this.http.delete(url);
  }
}
